import React from "react";
import PropTypes from "prop-types";
import WithErrorBoundary from "../../HOCs/WithErrorBoundary";
import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import FadeIn from "react-fade-in/lib/FadeIn";

import "./styles.scss";

function DropdownCountries({
  selectedCountry,
  changeSelectedCountry,
  countries,
}) {
  const titleOfButtons = (
    <div className="dropdownCountries__buttonsTitle">
      <p className="dropdownCountries__name">
        {
          countries?.find((country) => country.shortCode === selectedCountry)
            ?.name
        }
      </p>
      <i className="dropdownCountries__downIcon bi bi-chevron-down" />
    </div>
  );

  return (
    <DropdownButton
      className={`dropdownCountries`}
      as={ButtonGroup}
      title={titleOfButtons}
      bsPrefix=""
    >
      <FadeIn className="dropdownCountries__item">
        {countries?.map((country) => (
          <Dropdown.Item
            className={`dropdownCountries__country ${
              country.shortCode === selectedCountry ? "active" : ""
            }`}
            onClick={() => changeSelectedCountry(country.shortCode)}
            key={country.shortCode}
          >
            {country.name}
          </Dropdown.Item>
        ))}
      </FadeIn>
    </DropdownButton>
  );
}

DropdownCountries.propTypes = {
  selectedCountry: PropTypes.string,
  changeSelectedCountry: PropTypes.func,
  countries: PropTypes.array,
};

export default WithErrorBoundary(React.memo(DropdownCountries));
